import { Checkbox } from "../../../../components/common/Checkbox/Checkbox";
import Filter from "../../../../components/Filter/Filter";
import React, { useEffect, useState } from "react";
import { BarChart } from "../../../../components/common/RangeChart/RangeChart";
import { VehiclePopulationDashBoard } from "../../../../services/service-constants";
import navLeft from "../../../../assets/left-arrow-square.svg";
import navRight from "../../../../assets/right-arrow-square.svg";
import { mainAxiosInstance } from "../../../../services/service";
import { BarChartLarge } from "../../../../components/common/RangeChart/BarChartLarge";
import { useSelector } from "react-redux";
import Feedback from "../../../../components/common/ErrorComponents/Feedback";
import NotAuthorized from "../../../../components/common/ErrorComponents/NotAuthorized";
import ChartLoader from "../../../../components/common/ErrorComponents/ChartLoader";
import { useLocation } from "react-router-dom";
import Pagination from "../../../../components/common/Pagination";

const UPCompareWithVin = () => {
  const [selectAll, setSelectAll] = useState(true);
  const [chartData, setChartData] = useState([]);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showFilter, setShowFilter] = useState(true);
  const [selectedChartData, setSelectedChartData] = useState(null);
  const [diagnosesState, setDiagnosesState] = useState(null);
  const firstfilter = useSelector((state) => state.mainReducer.first_filter);
  const vinfilter = useSelector((state) => state.mainReducer.vin_filter);
  const [pageSize, setPageSize] = useState(0);
  const [pagination, setPagination] = useState(0);

  const filterOptions = [
    { displayname: "Engine Speed", id: "engineSpeedResponse", isChecked: true },
    {
      displayname: "Engine Oil Level",
      id: "engineOilLevelResponse",
      isChecked: true,
    },
    {
      displayname: "Tire Pressure",
      id: "tirePressureResponse",
      isChecked: true,
    },
    {
      displayname: "Engine Torque",
      id: "engineTorqueResponse",
      isChecked: true,
    },
    {
      displayname: "Transmission Oil Temperature",
      id: "transmissionOilTemperatureResponse",
      isChecked: true,
    },
    {
      displayname: "Engine Oil Temperature",
      id: "engineOilTemperatureResponse",
      isChecked: true,
    },
    {
      displayname: "Transmission Gear",
      id: "transmissionGearResponse",
      isChecked: true,
    },
    {
      displayname: "Engine Coolant Temperature",
      id: "engineCoolantTemperatureResponse",
      isChecked: true,
    },
  ];

  const [filterData, setFilterData] = useState([...filterOptions]);
  const [yAxisLabel, setYAxisLabel] = useState("Total number of miles");
  const [noDataFound, setNoDataFound] = useState(true);
  const [errorMsg, setErrorMsg] = useState(true);
  const [authenticationMsg, setAuthenticationMsg] = useState(false);
  const [filtData, setFiltData] = useState(null);
  const dataStore = [];
  const location = useLocation();

  const setSelectAllvalue = (data) => {
    const checkAllSelected = data.filter((el) => el.isChecked === false);
    if (checkAllSelected.length > 0) {
      setSelectAll(false);
    } else {
      setSelectAll(true);
    }
  };

  useEffect(() => {
    if (location?.state) {
      setDiagnosesState(location?.state?.diagnosesState);
    }
  }, [location]);

  useEffect(() => {
    const selectedData = JSON.parse(localStorage.getItem("selectedData"));
    const selectedDiagonsticsData = JSON.parse(
      localStorage.getItem("selectedDiagonosticsData")
    );
    const FilterSelectedValues = {
      ...selectedData,
      ...selectedDiagonsticsData,
    };
    setFiltData(FilterSelectedValues);
  }, []);

  const handleFilterClick = (val) => {
    const newFilterData = filterData.map((el) => {
      if (el.displayname === val.displayname) {
        el.isChecked = !el.isChecked;
      }
      return el;
    });

    const isAnyModuleSelected = newFilterData.some((el) => el.isChecked);
    setNoDataFound(!isAnyModuleSelected);
    setFilterData([...newFilterData]);
    setSelectAllvalue(newFilterData);
  };

  const valueMap = {
    engineCoolantTemperatureResponse: "temperatureInFahrenheit",
    transmissionGearResponse: "transmissionGear",
    engineOilTemperatureResponse: "oilTemperatureFahrenheit",
    transmissionOilTemperatureResponse: "transmissionOilTemperatureFahrenheit",
    engineTorqueResponse: "engineTorque",
    tirePressureResponse: "tirePressure",
    engineOilLevelResponse: "engineOilLevel",
    engineSpeedResponse: "engineSpeed",
  };

  const getChartData = async (response) => {
    const colorMap = {
      yellow: "#09A1A1",
      green: "#0574A6",
      red: "#DD359A",
      black: "#041E3E",
    };
    let mainData = [];
    let PaginationInfo = 1;
    Object.keys(response)?.map((key) => {
      PaginationInfo = response[key]?.totalPages;
      let resKey = valueMap[key];
      let meanData = [];
      let maxData = [];
      let minData = [];
      let resData = [];
      response[key]?.content?.map((data) => {
        meanData.push({
          y: data?.meanValue,
          color: data?.common ? colorMap["black"] : colorMap[data.threshold],
          maxValue: data?.maxValue,
          minValue: data?.minValue,
          iqr: data?.iqr,
          standardDeviation: data?.standardDeviation,
          variance: data?.variance,
          range: data?.range,
        });
        maxData.push({ y: data.maxValue });
        minData.push({ y: data.minValue });
        resData.push(data[resKey]);
        // resData.push(data?.xAxisValue);
      });
      mainData.push({
        name: key,
        PaginationInfo: PaginationInfo,
        data: [
          {
            data: [
              {
                type: "column",
                data: meanData,
                pointWidth: 10,
                name: "Miles",
              },
              {
                type: "line",
                data: maxData,

                marker: {
                  radius: 3,
                  symbol: "circle",
                  fillColor: {
                    radialGradient: {
                      cx: 0.5,
                      cy: 0.3,
                      r: 0.5,
                    },
                    stops: [
                      [0, "#FFFFFF"],
                      [1, "#DD359A"],
                    ],
                  },
                },
                lineColor: "#DD359A",
                lineWidth: 1,
                name: "Max",
              },
              {
                type: "line",
                data: minData,
                marker: {
                  radius: 3,
                  symbol: "circle",
                  fillColor: {
                    radialGradient: {
                      cx: 0.5,
                      cy: 0.3,
                      r: 0.5,
                    },
                    stops: [
                      [0, "#FFFFFF"],
                      [1, "#0574A6"],
                    ],
                  },
                },
                lineColor: "#0574A6",
                lineWidth: 1,
                name: "Min",
              },
            ],
            categories: resData,
          },
        ],
      });
    });
    setChartData(mainData);
  };

  useEffect(() => {
    getChartData(data);
  }, [data]);

  useEffect(() => {
    if (diagnosesState !== null) getPageData();
  }, [diagnosesState, pageSize]);

  useEffect(() => {
    setPagination(0);
  }, []);

  const getPageData = (val) => {
    const url = `${VehiclePopulationDashBoard.vp_up_compare_with_vin}/${diagnosesState}?page=${pageSize}&size=10`;
    let params = {};

    let paramData = {
      filterDto: {
        ...firstfilter,
        ...params,
      },
      vinNumberRequestDto: {
        vinNumber: vinfilter,
        make: "Ford",
        organizationId: 1,
      },
    };

    mainAxiosInstance
      .post(url, paramData)
      .then((response) => {
        if (response.status === 200) {
          setNoDataFound(false);
          setData(response.data);
        }
        if (response.status === 401) {
          setErrorMsg(response.data?.details || "You are not authorized.");
          setAuthenticationMsg(true);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setAuthenticationMsg(true);
          setErrorMsg(err.response.data?.details || "You are not authorized.");
        } else {
          setNoDataFound(true);
        }
      });
  };

  const getDataForBarChart = (element) => {
    const barChartData = chartData.filter((el) => el.name === element.id);
    dataStore.push(barChartData?.[0]?.data);
    return barChartData?.[0]?.data;
  };

  const getTotalPages = (element) => {
    const barChartData = chartData.filter((el) => el.name === element.id);
    const totalPages = barChartData[0]?.PaginationInfo;
    setPagination(totalPages);
  };

  const onPageChanged = (val) => {
    setPageSize(val);
  };

  const handleChartClick = (el) => {
    setShowModal(true);
    setSelectedChartData(el);
    setShowFilter(false);
    getTotalPages(el);

    const barChartData = chartData.filter((elemet) => elemet.name === el.id);
    const totalPages = barChartData[0]?.PaginationInfo;
    setPagination(totalPages);
  };

  const showPrev = (el) => {
    const data = filterData.filter((el) => el.isChecked);
    if (data.length > 0) {
      const index = data.findIndex((elem) => elem.id === el.id);
      let selectElement = el;
      if (index !== 0) {
        selectElement = data[index - 1];
      } else if (index === 0) {
        selectElement = data[data.length - 1];
      }
      setNoDataFound(false);
      setSelectedChartData(selectElement);
      getTotalPages(selectElement);
      setPageSize(0);
    } else {
      setNoDataFound(true);
    }
  };

  const clickOnClose = (e) => {
    setShowModal(false);
    setShowFilter(true);
    setPageSize(0);
  };
  const showNext = (el) => {
    const data = filterData.filter((el) => el.isChecked);

    if (data.length > 0) {
      const index = data.findIndex((elem) => elem.id === el.id);
      let selectElement = el;
      if (index !== data.length - 1) {
        selectElement = data[index + 1];
      } else if (index === data.length - 1) {
        selectElement = data[0];
      }
      setNoDataFound(false);
      setSelectedChartData(selectElement);
      getTotalPages(selectElement);
      setPageSize(0);
    } else {
      setNoDataFound(true);
    }
  };

  const AllSelect = (val) => {
    const getUpdatedfilterData = filterData.map((el) => {
      return { ...el, isChecked: val };
    });
    setFilterData(...[getUpdatedfilterData]);
    setSelectAll(val);
  };

  return (
    <div
      className="page-wrapper vehicle-usage"
      style={{ backgroundColor: "#EEEEEE" }}
    >
      <div className="flex page-content-header--filter">
        {showFilter === true && (
          <Filter data={AllSelect} selectAll={selectAll}>
            {filterData.map((el) => (
              <Checkbox
                title={el.displayname}
                handleInputClick={() => handleFilterClick(el)}
                alignProp={{
                  borderTop: "0.5px solid #C4C4C4",
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "10px",
                  alignItems: "baseline",
                  flexDirection: "row-reverse",
                }}
                checkboxStyle={{ marginRight: "10px" }}
                isChecked={el.isChecked}
              />
            ))}
          </Filter>
        )}
      </div>
      {!noDataFound && (
        <div className="legend-wrapper">
          <div className="legend">
            <div className="green-legend">
              <span className="line-box blue"></span>
              <span className="color-legend">Min Values</span>
            </div>
            <div className="green-legend">
              <span className="line-box red"></span>
              <span className="color-legend">Max Values</span>
            </div>
            <div className="green-legend">
              <span
                className="color-box black"
                style={{ marginRight: "5px" }}
              ></span>
              <span className="color-legend">Common in Vin</span>
            </div>
            <div className="green-legend">
              <span className="color-box green"></span>
              <span className="color-legend">Within the Expected range</span>
            </div>
            <div className="yellow-legend">
              <span className="color-box yellow"></span>
              <span className="color-legend">
                Within Expected range but too high/low
              </span>
            </div>
            <div className="red-legend">
              <span className="color-box pink"></span>
              <span className="color-legend">Outside Expected range</span>
            </div>
          </div>
        </div>
      )}
      <div>
        {noDataFound && !errorMsg && (
          <div>
            <Feedback />
          </div>
        )}
        {authenticationMsg && (
          <div>
            <NotAuthorized title={errorMsg} />
          </div>
        )}
        {noDataFound && !authenticationMsg && errorMsg && (
          <div>
            <ChartLoader />
          </div>
        )}
      </div>

      {!noDataFound && (
        <div className="page-chart-container vehicle-usage-charts">
          {!noDataFound &&
            filterData.map(
              (el) =>
                el.isChecked &&
                !showModal && (
                  <BarChart
                    id={el.id}
                    data={getDataForBarChart(el)}
                    // categories={getCategoryDataForBarChart(el)}
                    title={el.displayname}
                    yLabel={yAxisLabel}
                    onClickHandler={() => handleChartClick(el)}
                    fromVpUp={true}
                  />
                )
            )}

          {showModal && !noDataFound && (
            <>
              <div
                className="nav-icons"
                onClick={() => showPrev(selectedChartData)}
              >
                <img src={navLeft} alt="previous" />
              </div>
              <BarChartLarge
                id={selectedChartData.displayname}
                data={getDataForBarChart(selectedChartData)}
                title={selectedChartData.displayname}
                yLabel={yAxisLabel}
                clickOnClose={clickOnClose}
                fromVpUp={true}
              />
              <div
                className="nav-icons"
                onClick={() => showNext(selectedChartData)}
              >
                <img src={navRight} alt="previous" />
              </div>
            </>
          )}

          {dataStore?.length == 0 && (
            <div style={{ width: "900px" }}>
              <Feedback />
            </div>
          )}
        </div>
      )}
      {showModal && pagination > 1 && (
        <Pagination
          pageCount={pagination}
          pageRange={10}
          onPageChanged={onPageChanged}
          forcePage={pageSize}
        />
      )}
    </div>
  );
};

export default UPCompareWithVin;
